'use client'

import { Box, Flex, Heading, Text } from '@chakra-ui/react'
import { FC } from 'react'

export type ProcessStepProps = {
  number: number
  title: string
  description: string
}

const stoneShapes = [
  '50% 50% 50% 50% / 45% 45% 55% 55%',
  '45% 55% 48% 52% / 50% 45% 55% 50%',
  '52% 48% 45% 55% / 48% 52% 48% 52%',
  '48% 52% 52% 48% / 55% 45% 55% 45%',
  '50% 50% 45% 55% / 45% 50% 50% 55%'
]

const stoneOffsets = ['0', '40px', '15px', '40px', '0']

export const ProcessStep: FC<ProcessStepProps> = ({ number, title, description }) => {
  const shapeIndex = (number - 1) % stoneShapes.length
  const offset = stoneOffsets[shapeIndex]

  return (
    <Flex
      align="flex-start"
      gap={5}
      mb={8}
      ml={{ base: 0, md: offset }}
      position="relative"
      zIndex={1}
    >
      <Box
        w="56px"
        h="56px"
        bgGradient="linear(145deg, teal.500, teal.900)"
        color="white"
        borderRadius={stoneShapes[shapeIndex]}
        display="flex"
        alignItems="center"
        justifyContent="center"
        fontFamily="heading"
        fontSize="1.2rem"
        fontWeight={600}
        flexShrink={0}
        boxShadow="0 4px 8px rgba(27, 133, 145, 0.2), 0 2px 4px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.15)"
        position="relative"
        _after={{
          content: '""',
          position: 'absolute',
          inset: '3px',
          borderRadius: 'inherit',
          bg: 'radial-gradient(ellipse at 30% 20%, rgba(255,255,255,0.12) 0%, transparent 50%)'
        }}
      >
        {number}
      </Box>
      <Box>
        <Heading as="h3" fontFamily="heading" fontSize="1.25rem" fontWeight={500} mb={1}>
          {title}
        </Heading>
        <Text color="text.secondary" lineHeight={1.6}>
          {description}
        </Text>
      </Box>
    </Flex>
  )
}
